import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from 'react-bootstrap';

import {Wrapper} from '../system/wrapper';
import Input from 'form/input';
import Checkbox from 'form/checkbox';
import {ButtonRegistrationLogin} from 'components/buttons';
import {FailedLogin, SpanWrapper} from './components';

import {changeSignInRemember, changeLoginValue, signIn, cleanAuthForm} from 'redux/actions/auth';

const mapStateToProps = state => ({
  remember: state.auth.get('remember'),
  login: state.auth.get('loginItem'),
  isLoading: state.auth.get('isLoading'),
  hasError: state.auth.get('hasError')
});

const mapDispatchToProps = dispatch => ({
  changeRemember: (event) => dispatch(changeSignInRemember(event.target.checked)),
  changeValue: (value, key) => dispatch(changeLoginValue(value, key)),
  signIn: (event) => {
    event.preventDefault();
    dispatch(signIn())
  },
  onMount: () => dispatch(cleanAuthForm())
});

class Login extends Component {

  handleForgotPassword = () => {
    this.props.history.push('/forgot-password')
  }

  componentDidMount() {
    this.props.onMount();
  }
  componentWillUnmount(){
    this.props.onMount();
  }

  render() {
    return(
      <div>
        <Wrapper>
          <Grid>
            <h2>Увійти до системи</h2>
            <form onSubmit={this.props.signIn} style={{display: "flex", flexDirection: "column"}}>
              {this.props.hasError &&
              <FailedLogin>Виникла помилка при вході в систему. Будь ласка, перевірте правильність написання логіну та пароля.</FailedLogin>
              }
              <Input
                label="Логін:"
                type="text"
                placeholder="Введіть свою пошту"
                value={this.props.login.get('email') ? this.props.login.get('email') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'email')}
                required
              />
              <Input
                label="Пароль:"
                type="password"
                placeholder="Введіть свій пароль"
                value={this.props.login.get('password') ? this.props.login.get('password') : ""}
                onChange={(event) => this.props.changeValue(event.target.value, 'password')}
                required
              />
              <SpanWrapper>
                <Checkbox
                  label="Запам'ятати мене"
                  type="checkbox"
                  checked={this.props.remember}
                  onChange={this.props.changeRemember}
                />
                <div style={{cursor: 'pointer', padding: 15}} onClick={this.handleForgotPassword}>Забули пароль?</div>
              </SpanWrapper>
              <ButtonRegistrationLogin type="submit" value="Увійти"/>
            </form>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/auth/login.js